import { render, staticRenderFns } from "./IconSvgRtf.vue?vue&type=template&id=0b8d82a2&scoped=true&"
import script from "./IconSvgRtf.vue?vue&type=script&lang=js&"
export * from "./IconSvgRtf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8d82a2",
  null
  
)

export default component.exports